import i18n from "i18next";
import { initReactI18next, useTranslation } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import de from "./locales/de.json";
import en from "./locales/en.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";
import it from "./locales/it.json";
import pt from "./locales/pt.json";
import nl from "./locales/nl.json";

export const supportedLngs = {
  en: "English",
  de: "Deutsch",
//  fr: "Français",
  es: "Español",
//  it: "Italiano",
//  pt: "Português",
  nl: "Nederlands",
};

function normalizeLangCode(lng: string | undefined | null): string {
  if (!lng) return 'en';
  const base = lng.split('-')[0];
  return Object.keys(supportedLngs).includes(base) ? base : 'en';
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: normalizeLangCode(window.localStorage.getItem('language') || navigator.language),
    fallbackLng: 'en',
    debug: import.meta.env.VITE_DEBUG === "true",
    supportedLngs: Object.keys(supportedLngs),
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: { translation: en },
      de: { translation: de },
      fr: { translation: fr },
      es: { translation: es },
      it: { translation: it },
      pt: { translation: pt },
      nl: { translation: nl },
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'language',
      caches: ['localStorage'],
      checkWhitelist: true,
    },
  });

export const changeLanguage = (lng: string) => {
  const normalized = normalizeLangCode(lng);
  localStorage.setItem('language', normalized);
  i18n.changeLanguage(normalized);
  document.documentElement.lang = normalized;
};

export const getCurrentLanguage = () => {
  let currentLng = i18n.language || i18n.options?.fallbackLng as string;
  currentLng = normalizeLangCode(currentLng);
  if (localStorage.getItem('language')) {
    const stored = normalizeLangCode(localStorage.getItem('language'));
    if (stored !== currentLng) {
      i18n.changeLanguage(stored);
      currentLng = stored;
    }
    return stored;
  }
  return currentLng;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const _ = (key: string, options?: any) => {
  return i18n.t(key, options);
};

document.documentElement.lang = getCurrentLanguage();

export { useTranslation };
export default i18n;
